// @ts-nocheck
import { __assign, __read, __rest } from "tslib";
import './Tooltip.css';
import React, { useState } from 'react';
import { cn } from '../../utils/bem';
import { Popover } from '../Popover/Popover';
import { generateThemeClassNames, ThemeContext, useTheme } from '../Theme/Theme';
import { Typography } from '../Typography';
var ARROW_SIZE = 6;
var cnTooltip = cn('Tooltip');
export var tooltipPropSizes = ['m', 'l'];
export var tooltipPropSizesDefault = tooltipPropSizes[0];
function renderChildren(children) {
    return typeof children === 'string' || typeof children === 'number' ? (React.createElement(Typography.Title, null, children)) : (children);
}
export var Tooltip = React.forwardRef(function (props, ref) {
    var _a;
    var children = props.children, _b = props.size, size = _b === void 0 ? tooltipPropSizesDefault : _b, className = props.className, onSetDirectionProp = props.onSetDirection, style = props.style, staticPosition = props.staticPosition, directionPosition = props.directionPosition, view = props.view, firstLine = props.firstLine, secondLine = props.secondLine, rest = __rest(props, ["children", "size", "className", "onSetDirection", "style", "staticPosition", "directionPosition", "view", "firstLine", "secondLine"]);
    var theme = useTheme().theme;
    var _c = __read(useState(undefined), 2), direction = _c[0], setDirection = _c[1];
    var tooltipTheme = __assign(__assign({}, theme), { color: {
            primary: theme.color.primary
        } });
    var tooltipThemeClassNames = generateThemeClassNames(tooltipTheme);
    var onSetDirection = function (direction) {
        onSetDirectionProp && onSetDirectionProp(direction);
        setDirection(direction);
    };
    if (staticPosition) {
        return (React.createElement("div", __assign({}, rest, { ref: ref, className: cnTooltip({ staticPosition: staticPosition, view: view, size: size }, [className]), style: __assign({}, style) }),
            React.createElement("div", { className: cnTooltip('Background') }),
            React.createElement("div", { className: cnTooltip('Arrow', { direction: directionPosition }) }),
            React.createElement("div", { className: cnTooltip('Content', { size: size }) },
                view !== 'secondary' && renderChildren(children),
                view === 'secondary' && (firstLine || secondLine) && (React.createElement(React.Fragment, null,
                    firstLine && (React.createElement(Typography.Text, { size: "xs", weight: "bold", transform: "uppercase", className: cnTooltip('TextTop') }, firstLine)),
                    secondLine && (React.createElement(Typography.Text, { className: cnTooltip('TextBottom') }, secondLine)))))));
    }
    return (React.createElement(ThemeContext.Provider, { value: { theme: tooltipTheme, themeClassNames: tooltipThemeClassNames } },
        React.createElement(Popover, __assign({}, rest, { offset: ARROW_SIZE + 10, onSetDirection: onSetDirection, ref: ref, className: cnTooltip([className]), style: __assign((_a = {}, _a['--tooltip-arrow-size'] = "".concat(ARROW_SIZE, "px"), _a), style) }),
            React.createElement("div", { className: cnTooltip('Background') }),
            React.createElement("div", { className: cnTooltip('Arrow', { direction: direction }) }),
            React.createElement("div", { className: cnTooltip('Content', { size: size }) },
                view !== 'secondary' && renderChildren(children),
                view === 'secondary' && (React.createElement(React.Fragment, null,
                    React.createElement(Typography.Text, { size: "xs", weight: "bold", transform: "uppercase" }, firstLine),
                    React.createElement(Typography.Text, null,
                        secondLine,
                        " 123")))))));
});
